<div [ngClass]="{ smartbanner__disableDiv: !isSmartBannerOpen }" class="smartbanner">
  <div class="smartbanner__container">
    <div class="smartbanner__close">
      <mat-icon md-18 (click)="saveCookieNoBanner()">close</mat-icon>
    </div>
    <div class="smartbanner__icon">
      <img src="{{ iconUrl }}" alt="Icono letmino" />
    </div>
    <div class="smartbanner__content">
      <div class="smartbanner__appname">
        <b>{{ appName }}</b>
      </div>
      <div class="smartbanner__text">{{ authorName }}</div>
      <div class="smartbanner__text">{{ price }}</div>
    </div>
    <div class="smartbanner__content">
      <button
        mat-flat-button
        cdkFocusInitial
        class="accent"
        tabindex="0"
        [attr.aria-label]="'goToMarkt'"
        (click)="goToMarkt()">
        {{ buttonTxt }}
      </button>
    </div>
  </div>
</div>
